import { render, staticRenderFns } from "./Slides.vue?vue&type=template&id=2204f416&lang=html&"
import script from "./Slides.vue?vue&type=script&lang=js&"
export * from "./Slides.vue?vue&type=script&lang=js&"
import style0 from "./Slides.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports